import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';

import ProjectCreationWizard from '../components/projects/ProjectCreationWizard';

const CreateProjectPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Get the project ID from URL parameters (for editing)
  const editProjectId = searchParams.get('edit');

  const handleProjectComplete = (project) => {
    // Navigate to project dashboard or success page
    toast.success('Project submitted successfully!');
    navigate('/dashboard', { 
      state: { 
        message: 'Your project has been submitted and is under review. You will be notified once it\'s approved.' 
      }
    });
  };

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-neutral-50 py-8"
    >
      <div className="container mx-auto px-4">
        <ProjectCreationWizard 
          existingProjectId={editProjectId} 
          onComplete={handleProjectComplete} 
        />
      </div>
    </motion.div>
  );
};

export default CreateProjectPage;
